import * as React from 'react'
import { TableHead, Checkbox, TableSortLabel, Box } from '@mui/material'
import { visuallyHidden } from '@mui/utils'

import { columns } from './columns'
import { type HeaderTableBulkImportProps } from './types'
import { StyledCardTableCell, StyledCardTableRow } from './StyledTableBulkImport'

import { ReactComponent as CheckBoxIndeterminateIcon } from '@/assets/icons/checkbox-indeterminate.svg'
import { ReactComponent as CheckBoxIcon } from '@/assets/icons/checkbox-icon.svg'
import { ReactComponent as CheckBoxCheckedIcon } from '@/assets/icons/checkbox-checked-filled-icon.svg'
import { type CardActivityWithId } from '@/models/card-activity/card-activity.model'

export default function HeaderTableBulkImport(props: HeaderTableBulkImportProps) {
  const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort, visibleColumnIds } = props

  const createSortHandler = (property: keyof CardActivityWithId) => (event: React.MouseEvent<unknown>) => {
    onRequestSort(event, property)
  }

  return (
    <TableHead>
      <StyledCardTableRow>
        <StyledCardTableCell isTableHeader padding="checkbox">
          <Checkbox
            checked={rowCount > 0 && numSelected === rowCount}
            checkedIcon={<CheckBoxCheckedIcon />}
            icon={<CheckBoxIcon />}
            indeterminate={numSelected > 0 && numSelected < rowCount}
            indeterminateIcon={<CheckBoxIndeterminateIcon />}
            size="small"
            onChange={onSelectAllClick}
          />
        </StyledCardTableCell>

        {columns
          .filter(col => visibleColumnIds.includes(col.id))
          .map(col => {
            const isActiveSort = orderBy === col.id && order !== 'none'

            return (
              <StyledCardTableCell key={col.id} isTableHeader sortDirection={isActiveSort ? order : false}>
                <TableSortLabel
                  active={isActiveSort}
                  direction={isActiveSort ? order : 'asc'}
                  onClick={createSortHandler(col.id)}
                >
                  {col.label}
                  {isActiveSort ? (
                    <Box component="span" sx={visuallyHidden}>
                      {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                    </Box>
                  ) : null}
                </TableSortLabel>
              </StyledCardTableCell>
            )
          })}
      </StyledCardTableRow>
    </TableHead>
  )
}
